import { useMemo } from 'react';
import { useAppSelector } from '@src/core/hooks';
import { currentSaleSelector } from '@src/stores/sale';
import { currentSaleChangeSelector } from '@src/stores/saleChange';
import { currentOrderSelector, toPurchaseSummary as orderToPurchaseSummary } from '@src/features/orders';
import { toPurchaseSummary as saleToPurchaseSummary } from '@src/features/sales';
import type { PurchaseSummary } from '@src/common/types/purchaseSummary';

const narrowToChangedItem = (summary: PurchaseSummary, saleChange: { saleItemId?: string | null }): PurchaseSummary => {
  const item = summary.items.find(({ id }) => id === saleChange.saleItemId);

  return { ...summary, items: item ? [item] : [] };
};

export const usePurchaseSummary = () => {
  const order = useAppSelector(currentOrderSelector);
  const sale = useAppSelector(currentSaleSelector);
  const saleChange = useAppSelector(currentSaleChangeSelector);

  const summary = useMemo(() => {
    const resolved = order ? orderToPurchaseSummary(order) : saleToPurchaseSummary(sale);

    return saleChange ? narrowToChangedItem(resolved, saleChange) : resolved;
  }, [order, sale, saleChange]);

  return { summary, saleChange };
};
